module.exports = __webpack_public_path__ + "img/wrapbg3.3176dcba.png";